<div class="layout-sidebar" (mouseenter)="onMouseEnter()" (mouseleave)="onMouseLeave()">
  <div #menuContainer class="layout-menu-container">
    <app-menu></app-menu>
    <app-version-tag class="footer"></app-version-tag>
  </div>
</div>
